export const SETTINGS_PATH = '/settings';
export const BLOCKED_USERS_PATH = '/settings/blocked-users';
